import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query"

import { invalidationIntents } from "~/api/cache"

import type {
  UpdateProposalUtilitySelectionDto,
  UpdateProposalUtilitySelectionResponseDto,
} from "../dto/proposal-utility.dto"
import { proposalUtilityService } from "../services/proposal-utility.service"

export type UpdateProposalUtilitySelectionVariables = {
  proposalId: string
  data: UpdateProposalUtilitySelectionDto
}

export default function useUpdateProposalUtilitySelection(): UseMutationResult<
  UpdateProposalUtilitySelectionResponseDto,
  unknown,
  UpdateProposalUtilitySelectionVariables
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      proposalId,
      data,
    }: UpdateProposalUtilitySelectionVariables) =>
      proposalUtilityService.updateUtilitySelection(proposalId, data),
    onSuccess: (data, { proposalId }) => {
      // Same invalidations the GraphQL updateProposal mutation performs in
      // proposal-context, so downstream pricing/quote views refresh. When a
      // savings recalculation was queued, defer REST savings refetch until the
      // fresh snapshot lands (utilitySavingsRecalculating clears).
      void invalidationIntents.proposalPricingInputsChanged(
        queryClient,
        proposalId,
        { deferSavingsRefetch: data.recalcQueued },
      )
    },
  })
}
